export default "__VITE_ASSET__DzNu4I2u__"